import { TableContainer as MUITableContainer } from '@mui/material';
import { withStyles } from '@mui/styles';
import Theme from 'App.theme';

export const TableContainer = withStyles({
  root: {
    border: `2px solid ${Theme.greys.GREY1}`,
    borderRadius: '0.5rem',
    boxShadow: 'none',
    transition: 'all 0.3s',
    maxHeight: '100%',
    '& .set-table': {
      '& .MuiTableBody-root': {
        '& .MuiTableRow-root': {
          '&:hover': {
            cursor: 'default',
            background: '#ffffff',
          },
        },
      },
    },
    '& .MuiTableHead-root': {
      cursor: 'default',
      '& .tray-header': {
        padding: '0rem',
      },
      '& .MuiTableCell-head': {
        color: Theme.colours.black,
        background: Theme.greys.GREY1,
      },
    },
    '& .parts': {
      '& .MuiTableCell-root': {
        padding: '0.5rem',
      },
    },
    '& .MuiTableCell-root': {
      fontFamily: "'Poppins', sans-serif",
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '15rem',
    },
    '& .actions': {
      maxWidth: '3rem',
    },
    '& .MuiTableBody-root': {
      '& .default': {
        '&:hover': {
          cursor: 'default',
          background: 'unset',
        },
      },
      '& .MuiTableRow-root': {
        transition: 'all 0.3s',
        '& td': {
          borderBottom: `2px solid ${Theme.greys.GREY1}`,
        },
        '&:last-child': {
          '& td': {
            borderBottom: `0px`,
          },
        },
        '&:hover': {
          cursor: 'pointer',
          background: '#f4f4f4',
        },
      },
    },
  },
})(MUITableContainer);
